"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
var Retrieval_1 = require("./Retrieval");
var Introspection_1 = require("./Introspection");
/**
 * The top level query type
 */
var Query = /** @class */ (function (_super) {
    __extends(Query, _super);
    function Query() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Query";
        /**
         * Container element for all introspect sensor fields
         */
        _this.introspect = function (config) { return _this.push(function (registry) {
            var entity = new Introspection_1.Introspection();
            config(entity);
            return "introspect { " + entity.render(registry) + " }";
        }); };
        /**
         * Container element for all retrieve sensor fields
         */
        _this.retrieve = function (config) { return _this.push(function (registry) {
            var entity = new Retrieval_1.Retrieval();
            config(entity);
            return "retrieve { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Query;
}(Array));
exports.Query = Query;
//# sourceMappingURL=Query.js.map